










































































import { mapGetters, mapActions } from 'vuex'
import BankNavbar from '@/components/BankNavbar.vue'
import GenericModal from '@/components/GenericModal.vue'
import UserModal from '@/components/UserModal.vue'

export default {
  name: 'BankCustomerDetails',
  components: {
    BankNavbar,
    GenericModal,
    UserModal
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters([
      'currentBank',
      'currentBankId',
      'currentBankName',
      'currentCustomer',
      'currentCustomerId',
      'currentCustomerName',
      'currentCustomerPhone',
      'currentCustomerUsers',
      'currentCustomerAssessmentHistory',
      'currentQuarter',
      'currentYear',
      'riskLevels',
      'riskLevelClasses'
    ]),
    customerHasCurrentSubmission () {
      if (this.currentCustomerAssessmentHistory && Array.isArray(this.currentCustomerAssessmentHistory)) {
        for (let s=0, l=this.currentCustomerAssessmentHistory.length; s<l; s++) {
          if (this.currentCustomerAssessmentHistory[s].period == this.currentYear) return true
        }
      }
      return false
    }
  },
  methods: {
    ...mapActions([
      'loadBank',
      'loadCustomer',
      'deleteAssessmentSubmission'
    ]),

    reloadCurrentCustomer () {
      this.loadCustomer(this.currentCustomerId)
    },

    reviewSubmission (submission) {
      this.$router.push(`/customers/${this.currentCustomerId}/submissions/${submission.id}`)
    },

    async confirmArchiveSubmission (submission) {
      this.$refs.genericModal.confirm('Archive submission '+submission.submitted_on, 'Confirm', () => {this.archiveSubmission(submission)})
    },

    async archiveSubmission (submission) {
      const response = await this.deleteAssessmentSubmission(submission.id)
      if (!response.success) {
        this.$bvToast.toast(response.message, {
          title: 'Error',
          toaster: 'b-toaster-bottom-right',
          variant: 'danger',
          autoHideDelay: 5000
        })
        return
      }
      this.$bvToast.toast(response.message, {
        title: 'Success',
        toaster: 'b-toaster-bottom-right',
        variant: 'success',
        autoHideDelay: 3000
      })
      this.reloadCurrentCustomer()
    },

    newUser () {
      this.$refs.userModal.show({
        role: 'customer',
        bank_id: this.currentBankId,
        customer_id: this.currentCustomerId
      })
    },

    editUser (user: User) {
      this.$refs.userModal.loadAndShow(user)
    }
  },
  async mounted () {
    console.log('BankCustomerDetails.mounted')
    if (this.$route.params.hasOwnProperty('bankId')) {
      this.loadBank(this.$route.params.bankId)
    }
    await this.loadCustomer(this.$route.params.custId)
  },
  watch: {
  }
}
